export default "__VITE_ASSET__fea89569__"